/**
 * LE CLAVIER DE LA FENETRE D'UN CRENEAU (lot du 14/10/2026), en regle pure :
 * l'editeur la consulte a chaque touche qui remonte de ses champs.
 *
 * - `Entree` valide la fenetre (« Ajouter », ou « Enregistrer » sur un creneau
 *   existant), depuis n'importe quel champ.
 * - SAUF quand une liste ouverte l'a deja prise pour choisir son element :
 *   la liste annule la touche (`preventDefault`), et la fenetre ne valide pas
 *   un choix qui vient seulement d'etre fait.
 * - Dans les notes, `Maj+Entree` fait un retour a la ligne.
 * - `Tab` depuis les notes va droit au bouton qui valide : les boutons de pied
 *   « Supprimer » et « Annuler » restent derriere, a `Maj+Tab` ou a la souris
 *   (`Echap` annule deja).
 * - Une frappe en COMPOSITION (accent, saisie asiatique) n'est jamais lue :
 *   son `Entree` confirme le caractere, pas la fenetre.
 */
export type GesteDuClavier = 'valider' | 'vers-validation' | null;

export function gesteDuClavier(touche: {
  key: string;
  shiftKey: boolean;
  /** La touche vient du champ des notes. */
  dansLesNotes: boolean;
  /** Une liste ouverte l'a deja prise (`isDefaultPrevented()`). */
  dejaPrise: boolean;
  /** Composition en cours (`isComposing`). */
  composition: boolean;
  /** Consultation : rien ne s'enregistre, aucun bouton ne valide. */
  lecture: boolean;
}): GesteDuClavier {
  if (touche.dejaPrise || touche.composition || touche.lecture) return null;
  if (touche.key === 'Tab') return touche.dansLesNotes && !touche.shiftKey ? 'vers-validation' : null;
  if (touche.key !== 'Enter') return null;
  if (touche.dansLesNotes && touche.shiftKey) return null;
  return 'valider';
}
